import React from "react";
import BlogBGStyles from "./BlogBG.styles";

const { Container } = BlogBGStyles;

const BlogBG = () => {
    return <Container></Container>;
};

export default BlogBG;
